// Prevents pull-to-refresh gesture on mobile devices
// This controller prevents the browser from reloading the page when the user
// pulls down (swipes finger downward) while already at the top of the scrollable area

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.startY = 0
    this.#preventPullToRefresh()
  }

  disconnect() {
    this.#removePullToRefreshPrevention()
  }

  #preventPullToRefresh() {
    // Store bound functions so we can remove them later
    this.boundHandleTouchStart = this.#handleTouchStart.bind(this)
    this.boundHandleTouchMove = this.#handleTouchMove.bind(this)

    // Add event listeners with passive: false to allow preventDefault
    this.element.addEventListener('touchstart', this.boundHandleTouchStart, { passive: false })
    this.element.addEventListener('touchmove', this.boundHandleTouchMove, { passive: false })
  }

  #removePullToRefreshPrevention() {
    if (this.boundHandleTouchStart) {
      this.element.removeEventListener('touchstart', this.boundHandleTouchStart)
    }
    if (this.boundHandleTouchMove) {
      this.element.removeEventListener('touchmove', this.boundHandleTouchMove)
    }
  }

  #handleTouchStart(event) {
    // Store the initial Y position of the touch
    this.startY = event.touches[0].clientY
  }

  #handleTouchMove(event) {
    const currentY = event.touches[0].clientY
    const deltaY = currentY - this.startY

    // Check scroll position of both the element and the document
    const elementScrollTop = this.element.scrollTop
    const documentScrollTop = window.pageYOffset || document.documentElement.scrollTop
    const isAtTop = elementScrollTop === 0 && documentScrollTop === 0

    // deltaY > 0 means finger is moving down (pulling down to refresh)
    // Only prevent if we're at the top AND pulling down
    if (isAtTop && deltaY > 0) {
      event.preventDefault()
    }
  }
}
